module.exports = __webpack_public_path__ + "static/configure-inventory-for-out-of-stock-c59528024159347a1b0a4839e0ba3437.png";